import React from "react"
import { injectIntl } from "gatsby-plugin-intl"
import AboutUsPage from "@tmu/components/about"

const AboutUs = () => {
  return <AboutUsPage />
}

export default injectIntl(AboutUs)
